import handleTouchFallback from './handleTouchFallback';

/**
 * Attach interactions to every element that matches selector.
 */
$('.main-nav').each((_, nav) => {
    // Always apply default mobile touch behavior:
    $(nav).find('input[type=checkbox]').each((_, checkbox) => {
        $(checkbox).on('change', () => {
            // When a submenu is opened, then all parent list items should get closed.
            // Only the direct parent item of the current submenu should stay visible and
            // act as a back button.
            // The checked state of a checkbox refers to a submenu's open state.

            // So by default we close all parent list items.
            $(checkbox).parents('li').attr('data-active', false);

            // The direct parent list and item receive their open state according to the
            // checkbox state.
            $(checkbox).closest('ul').attr('data-active', checkbox.checked);
            $(checkbox).closest('li').attr('data-active', checkbox.checked);

            // If the checkbox is unchecked it means the submenu is closed.
            // Therefore we re-open the parent's parent item.
            if (!checkbox.checked) {
                $(checkbox).closest('li').parent().closest('li').attr('data-active', true);
            }
        });
    });

    $(window).on('load', () => {
        // Test if nav is not hidden behind burger menu
        if ($(nav).is(':visible')) {
            // Use touchstart once for fallback initialization
            $(nav).one('touchstart', handleTouchFallback(nav));
        }
    });
});



// WEBPACK FOOTER //
// ./src/scripts/components/main-nav/index.js